export default __webpack_public_path__ + "static/media/eretria_logo_footer.17875d40.png";